module.exports = __webpack_public_path__ + "img/arrowRigHthalfColonialWhite.b590e0a6.svg";